export default "__VITE_ASSET__c1dcc0d7__"